<template>
  <section class="col-3 p-0" id="section">
    <div class="container-burger-menu-button">

      <button @click="toggleMenu" class="burger-menu-button">
        <i class="fa fa-bars"></i>
      </button>

      <div class="active-filters">
        <span v-if="!areFiltersActive" class="active-filters-labels">Tous affichés</span>
        <span class="active-filters-labels selectedPostType-label">{{ selectedPostType }}</span>
        <span class="active-filters-labels">{{ activeMarkerTypes }}</span>
        <span class="active-filters-labels">{{ searchQuery }}</span>
      </div>
    </div>

    <div class="px-3 menu-burger-content" :class="{ open: isOpen }">

      <div id="direct-search">
        <div class="form-check">
          <input @click='(e) => this.selectedPostType = e.currentTarget.value'
                 class="mbw-cursor-change form-check-input type-select-radio" type="radio"
                 value="tous" name="type-select" id="tous">
          <label class="mbw-cursor-change form-check-label" for="tous">Tous</label>
        </div>

        <div class="form-check">
          <input @click='(e) => this.selectedPostType = e.currentTarget.value'
                 class="mbw-cursor-change form-check-input type-select-radio" type="radio"
                 value="etablissement" name="type-select" id="etablissement">
          <label class="mbw-cursor-change form-check-label" for="etablissement">Établissements</label>
        </div>

        <div class="form-check">
          <input @click='(e) => this.selectedPostType = e.currentTarget.value'
                 class="mbw-cursor-change form-check-input type-select-radio" type="radio"
                 value="service"
                 name="type-select" id="services">
          <label class="mbw-cursor-change form-check-label" for="services">Services</label>
        </div>

        <div class="form-check">
          <input @click='(e) => this.selectedPostType = e.currentTarget.value'
                 class="mbw-cursor-change form-check-input type-select-radio" type="radio"
                 value="association"
                 name="type-select" id=association>
          <label class="mbw-cursor-change form-check-label" for="association">Associations</label>
        </div>

        <div class="form-check">
          <input @click='(e) => this.selectedPostType = e.currentTarget.value'
                 class="mbw-cursor-change form-check-input type-select-radio" type="radio"
                 value="equipement"
                 name="type-select" id=equipements>
          <label class="mbw-cursor-change form-check-label" for="equipements">Équipements</label>
        </div>
      </div>

      <div class="my-3">
        <input @keyup.enter="executeSearch" ref="searchQuery" type="text" class="form-control" id="search-input"
               placeholder="Rechercher...">
      </div>

      <div class="my-3">
        <button @click="executeSearch" title="Rechercher" href="#" id="search-button" class="btn px-5">
          <i class="fa fa-search" aria-hidden="true"></i>
        </button>

        <button v-if="searchOn" @click="clearSearch" title="Réinitialiser la recherche" href="#" id="clear-button"
                class="btn btn-link mx-2">
          <i class="fa fa-undo" aria-hidden="true"></i> Réinitialiser la recherche
        </button>
      </div>

      <p class="search-result-count" v-if="searchOn">Nombre de résultats : {{ searchResultCount }}</p>

      <hr>

      <p v-if="Object.keys(filters).length < 1 && loaded" class="alert alert-info my-4">
        Aucun filtre disponible pour votre recherche
      </p>

      <fieldset v-for="(items, key) in filters" class="py-3" :key="key">
        <div id="filters-legends" :class="{ 'filter-open': isAccordionOpen(key) }">
          <i :class="['fas', 'fa-arrow-down', 'fa-xs', 'icon-arrow', { 'rotate': isAccordionOpen(key) }]"
             @click="toggleAccordion(key)"></i>
          <legend class="text-capitalize h5 m-0" @click="toggleAccordion(key)">{{ key }}</legend>
        </div>

        <div v-show="openAccordions[key]" v-for="(item, i) in items" :key="'item_' + i" class="form-check">
          <input @click="check" type="checkbox" class="mbw-cursor-change form-check-input type-select-radio"
                 :value="item.id"
                 :id="'check_' + i + '_' + item.id" :name="'checkbox_'+item.id">
          <label class="mbw-cursor-change form-check-label" :for="'check_' + i + '_' + item.id">
            {{ item.name }}<small class="fw-light text-white fst-italic mbw-item-count">({{ item.count }})</small>
          </label>
        </div>
      </fieldset>
    </div>
  </section>
</template>

<script>
export default {
  name: 'LeftSectionMobile',
  emits: ['execute-search', 'reset-search'],
  props: {
    params: Object,
    filters: Object,
    loaded: Boolean,
    searchResultCount: Number
  },

  data() {
    return {
      selectedPostType: null,
      searchOn: false,
      selectedMarkerTypes: [],
      activeMarkerTypes: '',
      isAccordionOpen(key) {
        return this.openAccordions[key];
      },
      searchQuery: "",
      openAccordions: {},
      isOpen: false
    }
  },

  watch: {
    selectedMarkerTypes: {
      handler(newValue, oldValue) {
        let filters = [];

        this.selectedMarkerTypes.forEach((id) => {
          const input = document.querySelector('input[name="checkbox_' + id + '"]');
          filters.push(input.parentNode.querySelector('label').textContent);
        });

        this.activeMarkerTypes = this.truncateText(filters.join(', ').replaceAll(/\([0-9]+\)/g, ''), 47);
      },
      deep: true
    },
  },

  computed: {
    areFiltersActive() {
      return this.searchQuery || this.selectedPostType || this.selectedMarkerTypes.length > 0;
    },
  },

  methods: {
    check(e) {
      if (e.currentTarget.checked) {
        this.selectedMarkerTypes.push(e.currentTarget.value);
      } else {
        this.selectedMarkerTypes.splice(this.selectedMarkerTypes.indexOf(e.currentTarget.value), 1);
      }
    },

    truncateText(text, maxLength) {
      if (text.length > maxLength) {
        return text.substring(0, maxLength) + "...";
      }
      return text;
    },

    toggleMenu() {
      this.isOpen = !this.isOpen;
    },

    toggleAccordion(key) {
      this.openAccordions[key] = !this.openAccordions[key];
    },

    checkAccordionCount() {
      const filterKeys = Object.keys(this.filters);
      if (filterKeys.length === 1) {
        this.openAccordions[filterKeys[0]] = true;
      }
    },

    executeSearch() {
      this.searchQuery = this.$refs.searchQuery.value;
      const search = this.$refs.searchQuery.value;
      const postType = this.selectedPostType;
      const markerTypes = this.selectedMarkerTypes.join();

      if (search || postType || markerTypes) {
        this.searchOn = true;
      }

      this.isOpen = false;
      this.$emit('execute-search', search, postType, markerTypes);
    },

    clearSearch() {
      this.searchOn = false;
      this.$refs.searchQuery.value = '';
      this.searchQuery = "";
      this.selectedPostType = null;
      this.selectedMarkerTypes = [];
      this.isOpen = false;
      this.$emit('reset-search', null, null);
    },
  },

  mounted() {
    this.searchQuery = this.params.search || "";

    if (this.params.postType) {
      this.searchOn = true;
      this.selectedPostType = this.params.postType;
      document.querySelector("input[name='type-select'][value='" + this.params.postType + "']").checked = true;
    } else {
      document.querySelector("input[name='type-select'][value='tous']").checked = true;
    }

    if (this.params.search) {
      this.searchOn = true;
      this.$refs.searchQuery.value = this.params.search;
    }

    if (this.params.markerTypes) {
      this.searchOn = true;
    }

    this.$nextTick(() => {
      if (this.params.markerTypes) {
        this.params.markerTypes.split(',').forEach(markerId => {
          this.selectedMarkerTypes.push(markerId)

          if (document.querySelector("input[name='checkbox_" + markerId + "']")) {
            document.querySelector("input[name='checkbox_" + markerId + "']").checked = true;
          }
        })
      }
    })
  },

  updated() {
    this.checkAccordionCount();
  }
}
</script>

<style scoped>

.form-check-input:checked[type=radio] {
  background-image: none;
}

.form-check-input {
  border: var(--border__2sb);
  transition: background-color 0.3s;
}

.form-check-input:checked {
  background-color: #f26a1b;
  border-color: white;
}

#search-button {
  background: #f26a1b;
  border: 2px solid white;
  border-radius: var(--border-radius__10);
  transition: all 200ms;
}

#search-button i {
  color: white;
}

#search-button:hover {
  transform: scale(0.9);
  opacity: 0.8;
  transition: all 350ms;
}

#clear-button {
  color: white;
  background: none;
  text-decoration: none;
}

@media (max-width: 398px) {
  #clear-button {
    padding: 0;
  }
}

@media (max-width: 359px) {
  #clear-button {
    padding-right: 16px;
    margin: 1.5rem 0rem 0rem 0rem !important;
  }
}

#search-input {
  border: var(--border__2sb);
  border-radius: var(--border-radius__10);
}

#filters-legends {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
}

.filter-open {
  margin-bottom: 10px;
}

.icon-arrow {
  transition: .3s;
  background: white;
  border-radius: 50%;
  color: var(--e-global-color-secondary);
}

.fa-arrow-down:before {
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.rotate {
  transform: rotate(180deg);
}

fieldset {
  border-bottom: 1px solid rgba(255, 255, 255, 0.25);
}

#section {
  background: var(--e-global-color-accent);
  color: white;
  overflow-y: hidden;
  height: var(--height__section-left-mobile);
  width: 100%;
}

.container-burger-menu-button {
  display: flex;
  align-items: center;
  height: var(--height__section-left-mobile);
  gap: 20px;
}

.menu-burger-content {
  display: none;
  transition: transform 0.3s ease-in-out;
  transform: translateY(-100%);
}

.menu-burger-content.open {
  display: flex;
  flex-direction: column;
  z-index: 1001;
  position: absolute;
  background: var(--e-global-color-accent);
  width: 100%;
  overflow-y: auto;
  height: var(--height__sections-left-n-right-mobile);
  transform: translateY(0);
  transition: transform 0.3s ease-in-out;
}

button.burger-menu-button {
  color: white;
  background: none;
  border: none;
  padding: 0;
  margin-left: 1rem;
  font-size: 50px;
  display: flex;
}

.active-filters {
  display: flex;
  flex-direction: column;
}

.selectedPostType-label {
  text-transform: capitalize;
}

.mbw-item-count {
  margin-left: 3px;
}
</style>
